import {connect} from 'react-redux';
import BowlEventItemForm from './BowlEventItemForm.jsx';
import {
  validateBowlEventForm,
  handleSaveBowlEventForm,
  handleCancelBowlEventForm,
  handleIsHandicappedClick,
  handleDeleteBowlEventForm
} from './actions';
import {formValueSelector} from 'redux-form';

const selector = formValueSelector('eventItemForm');

const mapStateToProps = state => ({
  validate: validateBowlEventForm,
  ageOptions: state.tournament.events.ageOptions,
  ageBased: selector(state,'ageBased'),
  numberOfBowlers: selector(state,'numberOfBowlers'),
  isHandicapped: selector(state,'isHandicapped'),
  handicapAppliedOptions: state.tournament.events.handicapAppliedOptions,
  readOnly: state.tournament.base.tournamentInfo.readOnly,
  availableLocationOptions: state.tournament.events.availableLocationOptions,
  readOnlyEvent: selector(state,'readOnly'),
  readOnlyDivisions: selector(state, 'readOnlyDivisions')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSaveBowlEventForm(data)),
  onCancel: () => dispatch(handleCancelBowlEventForm()),
  onIsHandicappedClick: (checked) => dispatch(handleIsHandicappedClick(checked)),
  onDelete: data => dispatch(handleDeleteBowlEventForm(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(BowlEventItemForm);



// WEBPACK FOOTER //
// ./src/features/tournament/events/BowlEventItemFormContainer.jsx